import React, { useEffect, useState } from 'react'
import { Select } from 'antd';
import { Option } from 'antd/es/mentions';
import { GetAll_ObjectInstance_Api } from '../../API/ObjectInstanceApi';
// ======================================================================

export const ObjectInstanceCombo = ({
    setLoading,
    showMessage,
    onChange
}) => {
    // ======================================================================
    const [objectInstance, setObjectInstance] = useState([]);
    // ======================================================================
    useEffect(() => {
        loadData();
    }, []);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_ObjectInstance_Api();
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setObjectInstance(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            // showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const handleChange = (value) => {
        if (onChange) onChange(value);
    };
    // ======================================================================
    return (
        <Select
            style={{ width: '100%' }}
            placeholder={"همه اتاق ها"}
            onChange={handleChange}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
            }
        >
            <Option value={null}>
                {"همه اتاق ها"}
            </Option>
            {objectInstance.map((objectInstance, key) => (
                <Option key={key} value={objectInstance.id}>
                    {objectInstance.title}
                </Option>
            ))}
        </Select>
    )
}